import { BasePage } from '@/components/ui/base-page'

export function SambbiPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add SambbiPage specific content here */}
    </BasePage>
  )
}